/* eslint-disable */
import React, { HTMLAttributes, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  EuiFlexItem,
  EuiFormRow,
  EuiFieldText,
  EuiSelect,
  EuiTextArea,
  EuiCheckbox,
  EuiComboBox,
  EuiFieldPassword,
  EuiCopy,
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFilePicker,
  EuiRadioGroup,
  EuiDatePicker,
  EuiSelectable,
  CommonProps,
  EuiFlexItemProps,
  EuiFilterButton,
  EuiIcon,
} from "@elastic/eui";
import Switch from "components/Buttons/Switch";
import MaskInput from "react-maskinput";
import LookupService from "services/LookupService";
import Validation from "Classes/Validation";
import FDPhoneNumberField from "./FDPhoneNumberField";
import FdDurationControl from "./FdDurationControl";
import { SelectEmptyValue } from "Consts";
import { getRandomString, filterNoOp, GetFormCellAuthorization, isNullOrUndefined } from "utils";
import { IControl, ValidationTypes } from "types/app";
import { globalFilterSelector } from "reduxStore/globalFilter/globalFilter.selectors";
import {
  EuiFormRowDisplayKeys,
  EuiFormRowProps,
} from "@elastic/eui/src/components/form/form_row/form_row";
import Popover from "components/Popover/Popover";

//todo: split by control type and inherit?

interface FDFormControlProps {
  control: Partial<IControl>;
  disableMaxWidth?: boolean;
  errorMessage?: string;
  flexWrapperProps?: CommonProps &
    HTMLAttributes<HTMLDivElement | HTMLSpanElement> &
    EuiFlexItemProps;
  formRowDisplay?: EuiFormRowDisplayKeys;
  fullWidth?: boolean;
  grow?: boolean | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | null;
  helpText?: string;
  lookups?: any;
  onChange: (controlObj: IControl, newVal: any, errMessage: string, newText: any) => any;
  rowProps?: Partial<EuiFormRowProps>;
  setFocus?: boolean;
  source?: any;
  wrapRowWithFlexItem?: boolean;
  maxWidth?: number;
  singleSelection?: boolean;
}

const FDFormControl: React.FunctionComponent<FDFormControlProps> = ({
  control,
  disableMaxWidth = false,
  errorMessage: ErrorMessage,
  flexWrapperProps = {},
  formRowDisplay = "row",
  fullWidth = false,
  grow = true,
  helpText,
  lookups: Lookups,
  onChange: OnChange,
  rowProps = {},
  setFocus = false,
  source: source = {},
  wrapRowWithFlexItem = true,
  maxWidth = 400,
}) => {
  const selectAll = "Select All";
  const selectCustomAll = "All current and future";
  const _selectAll = isNullOrUndefined(control?.selectCustomAll) ? selectAll : selectCustomAll;
  const { clientId } = useSelector(globalFilterSelector);
  const formatRadioValue = (val: any) => {
    return `${uniqueId}_${val}`;
  };
  const [errorMessage, setErrorMessage] = useState("");
  const [uniqueId] = useState(getRandomString() + control?.field);
  const initialValue: any =
    control?.inputType === "radiogroup"
      ? //@ts-ignore
        formatRadioValue(source[control?.field])
      : //@ts-ignore
        source[control?.field];

  const [value, setValue] = useState(initialValue);
  const [lookups, setLookups] = useState({});
  const [visible, setVisible] = useState(true);
  const [inputRef, setInputRef] = useState<any>(undefined);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [multiSelectOptions, setMultiSelectOptions] = useState<any>([]);

  const radioOptions =
    control?.inputType === "radiogroup"
      ? (control.options || []).map((option) => {
          const op = { ...option }; // we don't change the origin in case few radio groups on the page
          if (!op.originalid) {
            // in case of re-renders, don't  contact again to itself
            op.originalid = op.id;
            op.id = `${uniqueId}_${op.id}`;
          }

          return op;
        })
      : [];

  useEffect(() => {
    //@ts-ignore
    const newValue = source[control?.field];
    if (newValue === null || newValue === undefined || typeof newValue === "object") {
      if (newValue !== value) {
        setValue(newValue);
      }
    } else {
      let v = newValue;
      switch (control?.inputType) {
        case "radiogroup":
          v = formatRadioValue(newValue);
          break;
        case "switch":
        case "checkbox":
          v = Boolean(newValue);
          break;
        case "number":
        case "percentage":
          v = +newValue;
          break;
        default:
          v = newValue.toString();
          break;
      }
      if (v !== value) {
        setValue(v);
      }
    }
    //@ts-ignore
  }, [source[control?.field]]);

  useEffect(() => {
    if (typeof control?.visibleIf === "function") {
      const isVisible = control.visibleIf(source);
      setVisible(isVisible);
    }
  }, [JSON.stringify(source)]);

  useEffect(() => {
    if (typeof ErrorMessage === "string") setErrorMessage(ErrorMessage);
  }, [ErrorMessage]);

  useEffect(() => {
    setLookups(Lookups || {});
  }, [Lookups]);

  useEffect(() => {
    setErrorMessage("");
  }, [control?.validation]);

  const getSelectOptionText = (option: any) => {
    return option?.name ?? option?.type ?? option?.text;
  };

  const getSelectOptionValue = (option: any) => {
    return option?.id ?? option?.value ?? SelectEmptyValue;
  };

  const handleSelectedOption = useCallback(
    (Control: IControl, OnChange: any, data: any) => {
      if (!isNullOrUndefined(Control.selectedIndex)) {
        //@ts-ignore
        const selectedOption = data[Control.selectedIndex];

        if (selectedOption && !isNullOrUndefined(OnChange)) {
          OnChange(
            Control,
            getSelectOptionValue(selectedOption),
            null,
            getSelectOptionText(selectedOption)
          );
        }
      } else if (!isNullOrUndefined(Control.selectedValue)) {
        const selectedOption = data?.find(
          (o: any) => getSelectOptionValue(o) === Control.selectedValue
        );

        const text = getSelectOptionText(selectedOption);
        const value = getSelectOptionValue(selectedOption);

        if (selectedOption && !isNullOrUndefined(OnChange)) {
          // console.log("*** selectedOption --- ", selectedOption, text, value);
          // OnChange(Control, value, null, text);
          setValue(value);
        }
      } else if (!isNullOrUndefined(Control.selectedName)) {
        // debugger;
        const selectedOption = data.find(
          (o: any) => getSelectOptionText(o) == Control.selectedName
        );
        const text = getSelectOptionText(selectedOption);
        const value = getSelectOptionValue(selectedOption);

        if (selectedOption && !isNullOrUndefined(OnChange)) {
          OnChange(Control, text, null, value);
        }
      } else if (Control.defaultToSingleOption && data.length === 1) {
        if (!isNullOrUndefined(OnChange)) {
          OnChange(Control, getSelectOptionValue(data), null, getSelectOptionText(data[0]));
        }
      }
    },
    [control?.fdType, control?.options]
  );

  useEffect(() => {
    if (control?.fdType) {
      LookupService.getPromiseMyFDType(control.fdType, clientId).then((result) => {
        const _result = control.filterFunc
          ? result?.data.filter((option: any, index: number) => {
              return control.filterFunc ? control.filterFunc(option, index, source) : filterNoOp;
            })
          : result?.data;

        const initSelectedValues = control?.field ? source[control?.field] : [];
        const selectedValues = Array.isArray(initSelectedValues)
          ? initSelectedValues?.map((i) => i?.name)
          : [];

        const isSelectedValues = selectedValues?.length > 0;

        const initialOptions = [
          ...(control?.singleSelection
            ? []
            : [
                {
                  label: _selectAll,
                  value: _selectAll,
                  text: _selectAll,
                  ...(_selectAll === selectCustomAll && {
                    checked: isSelectedValues ? "" : "on",
                  }),
                },
              ]),
          ...(_result ?? []).map((t: any) => ({
            text: getSelectOptionText(t),
            label: getSelectOptionText(t),
            value: getSelectOptionValue(t),
            ...(isSelectedValues &&
              selectedValues.includes(getSelectOptionText(t)) && { checked: "on" }),
            ...t,
          })),
        ];

        setMultiSelectOptions(initialOptions);

        setLookups({
          ...lookups,
          //@ts-ignore
          [control.fdType]: (control.hideSelectOption
            ? []
            : [
                {
                  text: control.firstOption ?? "Select",
                  value: "",
                  label: control.firstOption ?? "Select",
                },
              ]
          ).concat(
            (_result ?? []).map((t: any) => ({
              text: getSelectOptionText(t),
              label: getSelectOptionText(t),
              value: getSelectOptionValue(t),
              ...t,
            }))
          ),
        });
        //@ts-ignore
        handleSelectedOption(control, OnChange, result.data);
      });
      //@ts-ignore
    } else if (control?.options) {
      if (control?.options?.length > 0) {
        const initialOptions = [
          ...(control?.singleSelection
            ? []
            : [
                {
                  label: _selectAll,
                  value: _selectAll,
                  text: _selectAll,
                  ...(_selectAll === selectCustomAll && { checked: "on" }),
                },
              ]),
          ...(control?.options || []),
        ];
        setMultiSelectOptions(initialOptions);
        //@ts-ignore
        handleSelectedOption(control, OnChange, control.options);
      } else {
        setMultiSelectOptions([]);
      }
    }
  }, [clientId, control?.fdType, control?.options, handleSelectedOption]);

  const onComboboxChange = (list: any) => {
    setValue(list || []);
    //@ts-ignore
    OnChange(
      control,
      list || [] //.map((l) => l.label)
    );
  };

  const onRadioGroupChange = (optionId: any) => {
    setValue(optionId);
    const originalId = radioOptions.find((op) => op.id === optionId).originalid;
    //@ts-ignore
    OnChange(control, originalId);
  };

  const onComboboxItemCreated = (item: any) => {
    const prevList = value || [];
    const newItem = typeof item === "string" ? { label: item } : item;
    const newData = [...prevList, newItem];

    setValue(newData);
    //@ts-ignore
    OnChange(control, newData);
  };

  const handleDatePickerChange = (date: any) => {
    setValue(date);
    //@ts-ignore
    OnChange(control, date);
  };

  const handleTimePickerChange = (date: any) => {
    setValue(date);
    //@ts-ignore
    OnChange(control, date);
  };

  const handleDurationChange = (durationObject: any) => {
    setValue(durationObject);
    //@ts-ignore
    OnChange(control, durationObject);
  };

  const onChange = (e: any) => {
    let newVal = null;
    let newText = "";
    //@ts-ignore
    if (["checkbox", "switch"].includes(control?.inputType)) {
      newVal = e.target.checked;
    } else {
      newVal =
        control?.inputType === "select"
          ? e.target.options[e.target.selectedIndex].value
          : e.target.value;

      newText =
        control?.inputType === "select"
          ? e.target.options[e.target.selectedIndex].text
          : e.target.value;
    }
    //@ts-ignore
    const errMessage = Validation.validateControl(control, newVal, source);
    setErrorMessage(errMessage);
    setValue(newVal);

    if (typeof OnChange === "function") {
      //@ts-ignore
      OnChange(control, newVal, errMessage, newText);
    }
  };

  const getFieldValue = (bool = false) => {
    if (control?.render) {
      return control.render(value || "");
    }
    if (control?.getValue) control.getValue(value || "");
    //debugger;
    return value ?? (bool ? false : SelectEmptyValue);
  };

  const getFieldLabel = () => {
    if (control?.showLabel === false) {
      return "";
    }
    return control?.label;
  };

  const onFileChanged = (blobs: any) => {
    if (blobs.length > 0) {
      const file = blobs[0]; // we dont support multiple files
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64data: any = reader.result;

        const newData = {
          fileStream: base64data
            .replace("data:image/png;base64,", "")
            .replace("data:application/pdf;base64,", ""),
          fileName: file.name,
          type: file.type,
        };
        //@ts-ignore
        const errMessage = Validation.validateControl(control, file, source);

        setErrorMessage(errMessage);
        setValue(newData);
        //@ts-ignore
        OnChange(control, newData);
      };
    } else {
      setValue(null);
      //@ts-ignore
      OnChange(control, null);
    }
  };

  const isControlDisabled = () => {
    if (typeof control?.disabled === "function") {
      return control.disabled(source);
    } else {
      return control.disabled || false;
    }
  };

  const getFormControl = () => {
    if (!visible) {
      return <></>;
    }
    let readonly = false;
    if (control?.permissionGroup) {
      const authorizationResult: any = GetFormCellAuthorization(control.permissionGroup);

      if (authorizationResult.NA === true) {
        return <></>;
      }

      if (!authorizationResult.RW) {
        readonly = true;
      }
    }
    //@ts-ignore
    if (typeof control?.isVisible === "function" && !control.isVisible(source)) {
      return <></>;
    }

    let input = <></>;
    let selectOptions: any[] = []; // for inputType= select

    const onSearchableChanged = (newOptions: any, e: any, changedOption: any) => {
      let optionsNewState: any = [...newOptions];

      if (changedOption.label === selectCustomAll && _selectAll === selectCustomAll) {
        const _options = optionsNewState.map((i: any) => ({
          ...i,
          checked: changedOption.label === i.label ? "on" : undefined,
        }));
        setMultiSelectOptions(_options);

        //@ts-ignore
        OnChange(control, []);
        return;
      }

      //if "Select All" clicked  check all the options
      if (changedOption.label === _selectAll && _selectAll !== selectCustomAll) {
        optionsNewState.forEach((op: any) => {
          op.checked = changedOption.checked === "on" ? "on" : undefined;
        });
      }

      const selectAllOption = optionsNewState.at(0);

      const allSelected = optionsNewState
        .filter((i: any) => i.label !== selectAll)
        .every((i: any) => i.checked == "on");

      if (selectAllOption && !control?.singleSelection) {
        //just a safety check not really needed
        if (!allSelected && selectAllOption?.checked == "on") {
          selectAllOption.checked = undefined;
        } else if (allSelected && selectAllOption?.checked == undefined) {
          selectAllOption.checked = "on";
        }
      }
      setMultiSelectOptions(optionsNewState);

      //@ts-ignore
      OnChange(
        control,
        optionsNewState.filter((i: any) => i.checked === "on")
      );
    };

    switch (control?.inputType) {
      case "password":
        input = (
          <EuiFieldPassword
            disabled={isControlDisabled()}
            //@ts-ignore
            inputRef={setInputRef}
            isInvalid={!!errorMessage}
            onChange={onChange}
            readOnly={readonly || control.readonly || false}
            value={getFieldValue()}
            fullWidth={fullWidth}
            style={{ background: "var(--card-background)" }}
          />
        );
        break;

      case "mask":
        input = (
          <MaskInput
            Name={control.field}
            alwaysShowMask
            className="euiFieldText"
            disabled={isControlDisabled()} // 00:00:00
            inputRef={setInputRef}
            mask={control.mask}
            maskChar="_"
            onChange={onChange}
            // isInvalid={!!errorMessage}
            readOnly={readonly || control.readonly || false}
            size={control.size || 10}
            value={getFieldValue()}
            {...control.controlProps}
          />
        );
        break;

      case "phone":
      case "linephone":
        input = (
          <FDPhoneNumberField
            controlProps={control.controlProps}
            disabled={isControlDisabled()}
            isInvalid={!!errorMessage}
            //@ts-ignore
            name={control.field}
            onChange={onChange}
            phone={getFieldValue()}
            readOnly={readonly || control.readonly || false}
            type={control.inputType}
            fullWidth={fullWidth}
          />
        );
        break;
      case "text":
        input = (
          <EuiFieldText
            id={uniqueId}
            inputRef={setInputRef}
            name={control.field}
            onChange={onChange}
            value={getFieldValue()}
            {...(control.controlProps || {})}
            disabled={isControlDisabled()}
            isInvalid={!!errorMessage}
            readOnly={readonly || control.readonly || false}
            placeholder={control?.placeholder || ""}
            fullWidth={fullWidth}
            style={control?.style ? control?.style : {}}
          />
        );
        break;

      case "textarea":
        input = (
          <EuiTextArea
            disabled={isControlDisabled()}
            id={uniqueId}
            inputRef={setInputRef}
            name={control.field}
            onChange={onChange}
            readOnly={readonly || control.readonly || false}
            value={getFieldValue()}
            {...(control.controlProps || {})}
            isInvalid={!!errorMessage}
            fullWidth={fullWidth}
            placeholder={control?.placeholder || ""}
            style={control?.style ? control?.style : {}}
          />
        );
        break;

      case "radiogroup":
        input = (
          <EuiRadioGroup
            className={control.horizontal ? "horizontal-radio-group" : ""}
            id={uniqueId} // todo: param for horizontal/ vertical
            idSelected={getFieldValue()}
            inputRef={setInputRef}
            onChange={(optionId) => {
              onRadioGroupChange(optionId);
            }}
            options={radioOptions}
            {...(control.controlProps || {})}
            name={uniqueId}
          />
        );
        break;
      case "checkbox":
        input = (
          <EuiCheckbox
            checked={value}
            id={uniqueId}
            inputRef={setInputRef} // showCheckboxRowLabel= label above the checkbox- instead of inline
            label={control.showCheckboxRowLabel ? null : getFieldLabel()}
            name={control.field}
            onChange={onChange}
            {...(control.controlProps || {})}
            disabled={isControlDisabled()}
            readOnly={readonly || control.readonly || false}
          />
        );
        break;
      case "switch":
        input = (
          <Switch
            checked={value}
            id={uniqueId}
            inputRef={setInputRef}
            label={getFieldLabel()}
            name={control.field}
            onChange={onChange}
            {...(control.controlProps || {})}
            // isInvalid={!!errorMessage}
            disabled={isControlDisabled()}
            readOnly={readonly || control.readonly || false}
          />
        );
        break;

      case "number":
        //assumption number is a positive number
        if (control.validation === undefined) {
          control.validation = ValidationTypes.Numeric;
        }
        input = (
          <EuiFieldText
            id={uniqueId}
            inputRef={setInputRef}
            min="0"
            name={control.field}
            onChange={onChange}
            readOnly={readonly || control.readonly || false}
            type="number"
            value={getFieldValue()}
            {...(control.controlProps || {})}
            disabled={isControlDisabled()}
            isInvalid={!!errorMessage}
            fullWidth={fullWidth}
            style={control?.style ? control?.style : {}}
          />
        );
        break;

      case "percentage":
        if (control.validation === undefined) {
          control.validation = ValidationTypes.Numeric;
        }
        input = (
          <EuiFieldText
            id={uniqueId}
            inputRef={setInputRef}
            max="100"
            min="0"
            name={control.field}
            onChange={onChange}
            readOnly={readonly || control.readonly || false}
            type="number"
            value={getFieldValue()}
            {...(control.controlProps || {})}
            disabled={isControlDisabled()}
            isInvalid={!!errorMessage}
            fullWidth={fullWidth}
            style={control?.style ? control?.style : {}}
          />
        );
        break;

      case "select": {
        // debugger
        const initialOptions = control.hideSelectOption
          ? []
          : [
              {
                text: control.firstOption || control?.placeholder || "Select",
                value: "",
              },
            ];

        if (control.fdType) {
          const result = control.filterFunc
            ? (lookups[control.fdType] || initialOptions).filter((option: any, index: number) => {
                return control.filterFunc ? control.filterFunc(option, index, source) : filterNoOp;
              })
            : lookups[control.fdType] || initialOptions;

          selectOptions = control?.firstOption
            ? [
                {
                  text: control.firstOption ?? "Select",
                  value: "",
                  label: control.firstOption ?? "Select",
                },
                ...result,
              ]
            : result;
        } else if (control?.field === "timezone") {
          selectOptions = initialOptions.concat(control.options ?? []).filter((option, index) => {
            return control.filterFunc ? control.filterFunc(option, index, source) : filterNoOp;
          });
        } else {
          selectOptions = initialOptions
            .concat(
              control.options ??
                [].sort((a: any, b: any) => {
                  if (a?.id?.localeCompare) {
                    return a?.id?.toString()?.localeCompare(b?.id?.toString());
                  } else if (a?.text?.localeCompare) {
                    return a?.text?.toString()?.localeCompare(b?.text?.toString());
                  } else {
                    if (getSelectOptionText(a) < getSelectOptionText(b)) {
                      return -1;
                    }
                    if (getSelectOptionText(a) > getSelectOptionText(b)) {
                      return 1;
                    }
                    return 0;
                  }
                })
            )
            .filter((option, index) => {
              return control.filterFunc ? control.filterFunc(option, index, source) : filterNoOp;
            });
        }

        let selectedVal = control?.firstOption
          ? SelectEmptyValue
          : (getFieldValue() ?? SelectEmptyValue);
        const valExists = selectOptions.some((op) => op.value == selectedVal);
        const optionsCount = control.hideSelectOption
          ? selectOptions.length
          : selectOptions.length - 1;

        if (!valExists && optionsCount > 0) {
          // debugger;
          console.error(
            control.field,
            "cannot find the value in the select. value:",
            selectedVal,
            selectOptions
          );

          selectedVal = selectOptions?.at(0)?.value ?? SelectEmptyValue;
          setValue(selectedVal);
        }

        input = (
          <EuiSelect
            aria-label={control.field}
            disabled={readonly || control.disabled || control.readonly || false}
            id={uniqueId}
            inputRef={setInputRef}
            name={control.field}
            onChange={onChange}
            options={selectOptions}
            placeholder={control?.placeholder || "Select"}
            fullWidth={fullWidth}
            value={selectedVal || value}
            {...(control.controlProps || {})}
            isInvalid={!!errorMessage}
            style={control?.style ? control?.style : {}}
          />
        );
        break;
      }

      case "combobox":
        input = (
          <EuiComboBox
            fullWidth
            id={uniqueId}
            inputRef={setInputRef}
            isClearable
            name={control.field}
            noSuggestions={control.noSuggestions !== undefined ? control.noSuggestions : true}
            onChange={onComboboxChange}
            onCreateOption={control.disableCreation ? null : onComboboxItemCreated}
            options={control.options}
            placeholder=""
            readOnly={readonly || control.readonly || false}
            selectedOptions={(Array.isArray(value) ? value : []).map((item) => {
              if (typeof item !== "object") {
                return {
                  label: item.label ?? item,
                };
              } else {
                return item;
              }
            })}
            {...(control.controlProps || {})}
            isDisabled={isControlDisabled()}
            isInvalid={!!errorMessage}
            style={control?.style ? control?.style : {}}
          />
        );
        break;

      case "file":
        input = (
          <EuiFilePicker
            display="default"
            initialPromptText={
              control.initialPromptText
                ? control.initialPromptText
                : "Select or drag and drop a file"
            }
            //@ts-ignore
            inputRef={setInputRef}
            multiple={false}
            onChange={onFileChanged}
            style={control?.style ? control?.style : {}}
          />
        );
        break;

      case "date_picker":
        input = (
          <EuiDatePicker
            id="form_control"
            isInvalid={!!errorMessage}
            onChange={handleDatePickerChange}
            selected={getFieldValue()}
            {...(control.controlProps || {})}
            dateFormat={
              control?.controlProps?.showTimeFormat === false ? "MMM D, YYYY" : "MMM D, YYYY HH:mm"
            }
            fullWidth={fullWidth}
            css={{
              background: "var(--card-background)",
              boxShadow: "inset 0 0 0 1px var(--border-color)",
              ...(control?.style && control?.style),
            }}
          />
        );
        break;
      case "time_picker":
        input = (
          <EuiDatePicker
            isInvalid={!!errorMessage}
            onChange={handleTimePickerChange}
            selected={getFieldValue()}
            showTimeSelect
            showTimeSelectOnly
            dateFormat="HH:mm A"
            timeFormat="HH:mm A"
            {...(control.controlProps || {})}
            calendarClassName="no-tooltips"
            style={control?.style ? control?.style : {}}
          />
        );
        break;
      case "duration":
        if (control.validation === undefined) {
          control.validation = ValidationTypes.PositiveNumber;
        }
        input = (
          <FdDurationControl
            ControlProps={control.controlProps}
            Name={control.field}
            disabled={isControlDisabled()}
            inputRef={setInputRef}
            isInvalid={!!errorMessage}
            onChange={handleDurationChange}
            readOnly={readonly || control.readonly || false}
            value={value}
          />
        );
        break;

      case "searchable":
        input = (
          <Popover
            style={{ minWidth: "100px", width: "100%" }}
            button={
              <EuiFlexGroup gutterSize="none">
                <EuiFlexItem grow>
                  <EuiFilterButton
                    hasActiveFilters={
                      !!multiSelectOptions?.find((item: any) => item?.checked === "on")
                    }
                    iconType="arrowDown"
                    isSelected={isPopoverOpen}
                    numActiveFilters={
                      multiSelectOptions?.filter(
                        (item: any) => item.label !== _selectAll && item?.checked === "on"
                      ).length
                    }
                    numFilters={
                      multiSelectOptions?.filter(
                        (item: any) => item.label !== _selectAll && item?.checked !== "off"
                      ).length
                    }
                    onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                    style={{
                      width: "100%",
                      color: "var(--text)",
                      boxShadow: "var(--box-shadow)",
                      backgroundColor: "var(--card-background3)",
                      border: "1px solid var(--border-color)",
                      borderRadius: "10px",
                    }}>
                    {control?.label || ""}
                  </EuiFilterButton>
                </EuiFlexItem>
              </EuiFlexGroup>
            }
            onClose={() => {
              setIsPopoverOpen(false);
            }}
            isOpen={isPopoverOpen}
            panelPaddingSize="none"
            children={
              <EuiSelectable
                {...(control.controlProps || {})}
                style={{ width: "551px" }}
                searchable
                singleSelection={control?.singleSelection || false}
                listProps={{ showIcons: false }}
                allowExclusions={false}
                onChange={onSearchableChanged}
                options={multiSelectOptions}
                searchProps={{
                  placeholder: "",
                  compressed: false,
                  css: {
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    borderBottom: ".6px solid var(--border-color)",
                    boxShadow: "none",
                    backgroundColor: "var(--card-background)",
                  },
                }}
                renderOption={(option) => (
                  <div style={{ position: "relative" }}>
                    <EuiCheckbox
                      id={`checkbox_${option.label}`}
                      checked={option?.checked === "on"}
                      onChange={() => {}}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      label={
                        <div
                          style={{
                            position: "absolute",
                            left: 0,
                            paddingLeft: "24px",
                          }}>
                          <span>{option.label}</span>
                        </div>
                      }
                    />
                  </div>
                )}>
                {(list, search) => (
                  <>
                    {search}
                    {list}
                  </>
                )}
              </EuiSelectable>
            }
          />
        );
        break;
      default:
        break;
    }

    if (control?.copy) {
      const row = (
        <EuiFormRow
          className={control.required && !control.hideRequiredSymbol ? "row-required" : ""}
          display={formRowDisplay}
          error={errorMessage}
          fullWidth={fullWidth}
          helpText={helpText || control.helpText || null}
          isInvalid={!!errorMessage}
          label={
            //@ts-ignore
            ["checkbox", "switch"].includes(control.inputType) && !control.showCheckboxRowLabel
              ? null
              : //@ts-ignore
                getFieldLabel(control)
          }
          {...(rowProps ?? {})}>
          <>
            <EuiFlexGroup gutterSize="none" responsive={false}>
              <EuiFlexItem grow={false}>{input}</EuiFlexItem>
              <EuiFlexItem grow={false}>
                <EuiCopy textToCopy={value || ""}>
                  {(copy) => (
                    <EuiButtonEmpty
                      color="text"
                      data-testid="btn-copy"
                      iconType="copy"
                      onClick={copy}
                      size="s"
                    />
                  )}
                </EuiCopy>
              </EuiFlexItem>
            </EuiFlexGroup>
          </>
        </EuiFormRow>
      );

      if (setFocus && inputRef && typeof inputRef?.focus === "function") {
        inputRef.focus();
      }
      return !wrapRowWithFlexItem ? (
        row
      ) : (
        <EuiFlexItem grow={grow || control.grow === true} {...(flexWrapperProps ?? {})}>
          <EuiFlexGroup alignItems="flexStart" gutterSize="none">
            <EuiFlexItem grow style={disableMaxWidth ? {} : { maxWidth }}>
              {row}
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      );
    } else {
      const row = (
        <EuiFormRow
          className={control?.required && !control.hideRequiredSymbol ? "row-required" : ""}
          display={formRowDisplay}
          error={errorMessage}
          fullWidth={fullWidth}
          helpText={helpText || control?.helpText || null}
          isInvalid={!!errorMessage}
          label={
            //@ts-ignore
            ["checkbox", "switch"].includes(control?.inputType) && !control.showCheckboxRowLabel
              ? null
              : //@ts-ignore
                getFieldLabel(control)
          }
          {...(rowProps ?? {})}>
          {input}
        </EuiFormRow>
      );

      if (setFocus && inputRef && typeof inputRef?.focus === "function") {
        inputRef.focus();
      }
      return !wrapRowWithFlexItem ? (
        row
      ) : (
        <EuiFlexItem grow={grow || control?.grow === true} {...(flexWrapperProps ?? {})}>
          {row}
        </EuiFlexItem>
      );
    }
  };

  return getFormControl();
};

export default FDFormControl;
